import { defineRouting } from 'next-intl/routing';

export const routing = defineRouting({
    locales: ['en', 'fr', 'es', 'pt'],
    defaultLocale: 'en',
    pathnames: {
        '/': '/',
        '/tv-rights-buyers': {
            fr: '/acheteurs-droits-tv',
            es: '/compradores-derechos-tv',
            pt: '/compradores-direitos-tv',
        },
        '/tv-rights-sellers': {
            fr: '/vendeurs-droits-tv',
            es: '/vendedores-derechos-tv',
            pt: '/vendedores-direitos-tv',
        },
        '/programs': {
            fr: '/programmes',
            es: '/programas',
            pt: '/programas',
        },
        '/studio/dashboard': {
            fr: '/studio/dashboard',
            es: '/studio/dashboard',
            pt: '/studio/dashboard',
        },
        '/studio/programs': {
            fr: '/studio/programmes',
            es: '/studio/programas',
            pt: '/studio/programas',
        },
        '/studio/formats': {
            fr: '/studio/formats',
            es: '/studio/formats',
            pt: '/studio/formats',
        },
        '/programs/[id]': {
            fr: '/programmes/[id]',
            es: '/programas/[id]',
            pt: '/programas/[id]',
        },
        '/settings': {
            fr: '/parametres',
            es: '/ajustes',
            pt: '/configuracoes',
        },
        '/studio/licenses': {
            fr: '/studio/licenses',
            es: '/studio/licenses',
            pt: '/studio/licenses',
        },
        '/credits': {
            fr: '/credits',
            es: '/credits',
            pt: '/credits',
        },
        '/transactions': {
            fr: '/transactions',
            es: '/actas',
            pt: '/transações',
        },
        '/cart': {
            fr: '/panier',
            es: '/carrito',
            pt: '/carrinho',
        },
        '/cart/confirmation-page/[id]': {
            fr: '/panier/page-de-confirmation/[id]',
            es: '/carrito/pagina-de-confirmacion/[id]',
            pt: '/carrinho/pagina-de-confirmacao/[id]',
        },
        '/marketing': {
            fr: '/marketing',
            es: '/marketing',
            pt: '/marketing',
        },
        '/formats': {
            fr: '/formats',
            es: '/formats',
            pt: '/formats',
        },
        '/formats/[id]': {
            fr: '/formats/[id]',
            es: '/formats/[id]',
            pt: '/formats/[id]',
        },
    },
});
